/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EC2Volume { 
    /**
     * Volume ID
     */
    id: string;
    /**
     * EBS Volume name
     */
    name: string;
    /**
     * Size in GiB
     */
    size_gib: number;
    /**
     * Created timestamp in UTC
     */
    created_timestamp: Date;
}

